import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "monthlyBtn", "yearlyBtn",
    "proPrice", "proPeriod", "proYearlySub",
    "teamPrice", "teamPeriod", "teamYearlySub",
    "businessPrice", "businessPeriod", "businessYearlySub",
    "signupLink"
  ]

  static values = {
    proMonthly: Number,
    proYearlyEquiv: Number,
    proYearlyTotal: Number,
    teamMonthly: Number,
    teamYearlyEquiv: Number,
    teamYearlyTotal: Number,
    businessMonthly: Number,
    businessYearlyEquiv: Number,
    businessYearlyTotal: Number
  }

  connect() {
    this.interval = "yearly"
  }

  selectMonthly() {
    this.interval = "monthly"
    this.monthlyBtnTarget.classList.add("bg-white", "text-gray-900", "shadow-sm")
    this.monthlyBtnTarget.classList.remove("text-gray-600")
    this.yearlyBtnTarget.classList.remove("bg-white", "text-gray-900", "shadow-sm")
    this.yearlyBtnTarget.classList.add("text-gray-600")
    this.updatePrices()
  }

  selectYearly() {
    this.interval = "yearly"
    this.yearlyBtnTarget.classList.add("bg-white", "text-gray-900", "shadow-sm")
    this.yearlyBtnTarget.classList.remove("text-gray-600")
    this.monthlyBtnTarget.classList.remove("bg-white", "text-gray-900", "shadow-sm")
    this.monthlyBtnTarget.classList.add("text-gray-600")
    this.updatePrices()
  }

  updatePrices() {
    const yearly = this.interval === "yearly"

    this.proPriceTarget.textContent = `$${yearly ? this.proYearlyEquivValue : this.proMonthlyValue}`
    this.proPeriodTarget.textContent = "/mo"
    this.proYearlySubTarget.style.display = yearly ? "" : "none"

    this.teamPriceTarget.textContent = `$${yearly ? this.teamYearlyEquivValue : this.teamMonthlyValue}`
    this.teamPeriodTarget.textContent = "/mo"
    this.teamYearlySubTarget.style.display = yearly ? "" : "none"

    this.businessPriceTarget.textContent = `$${yearly ? this.businessYearlyEquivValue : this.businessMonthlyValue}`
    this.businessPeriodTarget.textContent = "/mo"
    this.businessYearlySubTarget.style.display = yearly ? "" : "none"

    this.signupLinkTargets.forEach(link => {
      const url = new URL(link.href, window.location.origin)
      url.searchParams.set("interval", yearly ? "year" : "month")
      link.href = url.toString()
    })
  }
}
